import { AxiosResponse } from "axios";
import httpClient from "../../api/httpClient";
import { DashAcompProducao } from "../classes/DashAcompProducao";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
    { method: "GET", rota: "DashboardOtif" },
];

const apiServico: string = "DASHBOARD";

export default class DashOtifDataset extends httpClient {
    constructor() {
      super(apiServico);
    }
  
    async getAll(
      contratoSap: string[],
      sku: string[],
      dataInicio: Date,
      dataFim: Date,
      parceiros: number[]
    ): Promise<DashAcompProducao> {
      let ok: boolean = false;
      let data: DashAcompProducao;
      let error: any = undefined;
  
      let params = `dataInicial=${dataInicio.toDateString()}&dataFinal=${dataFim.toDateString()}`;

      parceiros.forEach(x=> params += `&codigoFornecedorSap=${x}`);
      sku.forEach(x=> params += `&sku=${x}`);
      contratoSap.forEach(x=> params += `&numerocontrato=${x}`);

      await super
        .Get( `${calls[0].rota}?${params}`)
        .then((response: AxiosResponse) => {
          ok = response.status === 200;
          data = response.data;
        })
        .catch((erro) => {
          ok = false;
          error = erro;
        });
      if (error !== undefined && ok === false) throw error;
      return new Promise<DashAcompProducao>((resolve) => {
        resolve(data);
      });
    }
  }
  